import { compose } from 'redux';

import {
    WithFetchDatasByParamsFromCMSInputProps,
    WithFetchDatasByParamsFromCMS,
} from 'modules/shared-cms-advanced/hocs';
import {
    WithStatelessDatasFetchingByParameters,
    WithNotifyRessourceLoaded,
    WithNotifyRessourceLoadedInputProps,
} from 'modules/shared/hocs';
import { cacheQueryService } from 'modules/shared/services';

import { WithCatalogueSEO } from '../../hocs';
import { brandService } from '../../services';
import { Brand, GetBrand } from '../../models';

import { BrandProps } from './brand-type';
import { QUERY } from './brand-query';
import { BrandLoader } from './brand-loader';

const getRessourceName = (props?: BrandProps): string | undefined => {
    if (props && props.brand) {
        return props.brand.name;
    }

    return undefined;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getParams = (props?: any): { key: string; value: string }[] => {
    if (!props) {
        return [];
    }
    const brandProps: Brand | undefined = props.brand;
    const brandId = `${brandProps ? (brandProps.id || '').trim() : ''}`;
    const parentBrandId = `${brandProps ? (brandProps.parentBrandId || '').trim() : ''}`;
    return [
        { key: 'signId', value: `${brandProps ? brandProps.signId : '-1'}` },
        { key: 'brandId', value: brandId !== '' ? brandId : '-1' },
        { key: 'parentBrandId', value: parentBrandId !== '' ? parentBrandId : '-1' },
    ];
};

const enhancer = compose<
    React.ComponentType<GetBrand & WithFetchDatasByParamsFromCMSInputProps & WithNotifyRessourceLoadedInputProps>
>(
    WithStatelessDatasFetchingByParameters<Brand, BrandProps, GetBrand>(
        cacheQueryService.cacheWithParams('getBrand', brandService.get),
        BrandLoader,
        'redirect',
        'brand',
        ['id'],
    ),
    WithFetchDatasByParamsFromCMS<BrandProps>(
        BrandLoader,
        QUERY,
        undefined,
        [
            { name: 'signAdvantageFilter', filter: "data/signId/iv eq '$signId'" },
            {
                name: 'brandAdvantageFilter',
                filter: 'data/brandId/iv eq $brandId or data/brandId/iv eq $parentBrandId',
            },
            { name: 'cornerFilter', filter: "data/brandId/iv eq $brandId and data/typeMarque/iv eq 'catalogue'" },
        ],
        undefined,
        true,
        getParams,
    ),
    WithNotifyRessourceLoaded(getRessourceName, undefined, props => {
        const brandName = getRessourceName(props);
        if (brandName) {
            return { typeName: 'marque', value: brandName };
        }

        return undefined;
    }),
    WithCatalogueSEO<BrandProps>('brand'),
);
export default enhancer;
